import Datatable from "../../Components/Datatable"
import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EXPRESS_BASE_URL } from "../../../../../Helpers/apiConfig";

const AcceptIcon = ({ accepted }) => (
    <FontAwesomeIcon
        icon={accepted ? "fas fa-check-circle" : "fas fa-times-circle"}
        style={{ color: accepted ? "green" : "#dc3545", fontSize: "18px" }}
    />
);

// Bireysel kullanicilarin (kayit formu veya Google ile uye olanlar)
// IndividualMembershipApproval kayitlarinin tam listesi.
export const AdminIndividualAcceptanceList = () => {
    const [data, setData] = useState([]);
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);

    const columns = React.useMemo(
        () => [
            {
                Header: "İsim",
                Footer: "İsim",
                accessor: 'name',
            },
            {
                Header: "E-posta",
                Footer: "E-posta",
                accessor: 'email',
            },
            {
                Header: "Tarih",
                Footer: "Tarih",
                accessor: 'tarihText',
            },
            {
                Header: "Ticari İleti",
                Footer: "Ticari İleti",
                accessor: (row) => <AcceptIcon accepted={!!row.ticariiletiRaw} />,
                id: 'ticariileti',
            },
            {
                Header: "Kullanım Sözleşmesi",
                Footer: "Kullanım Sözleşmesi",
                accessor: (row) => <AcceptIcon accepted={!!row.kullanimsozlesmesiRaw} />,
                id: 'kullanimsozlesmesi',
            },
            {
                Header: "KVKK",
                Footer: "KVKK",
                accessor: (row) => <AcceptIcon accepted={!!row.kvkkRaw} />,
                id: 'kvkk',
            },
        ],
        [],
    )

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Access-Control-Allow-Origin': '*',
                };
                const res = await axios({
                    method: 'get',
                    url: `${EXPRESS_BASE_URL}/getindividualmembershipapprovals`,
                    headers: headerss
                });

                const rows = Array.isArray(res.data) ? res.data : [];
                const mapped = rows.map((row) => {
                    const tarihDate = row.tarih ? new Date(row.tarih) : null;
                    return {
                        name: row.name,
                        email: row.email,
                        tarihText: tarihDate ? tarihDate.toLocaleString("tr-TR") : "-",
                        ticariiletiRaw: row.ticariileti,
                        kullanimsozlesmesiRaw: row.kullanimsozlesmesi,
                        kvkkRaw: row.kvkk,
                    };
                });
                setData(mapped);
            } catch (err) {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>Üyelik Kabulleri</h1>
            </div>
            <h4>{msg}</h4>
            {loading && <div>Veriler Yükleniyor!</div>}

            {!loading && (
                <div>
                    <Datatable data={data} columns={columns} tableBaslik="Üyelik Kabulleri" />
                </div>
            )}
        </div>
    );
};
export default AdminIndividualAcceptanceList;
